function hasLoggedIn() {
    return Boolean(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem('mma-mfe__from-login'));
}
export function hasNotLoggedIn() {
    return !hasLoggedIn();
}
export default hasLoggedIn;
//# sourceMappingURL=hasLoggedIn.js.map